// Italian
export const locale = {
  lang: 'it',
  data: {
    TRANSLATOR: {
      SELECT: 'seleziona la tua lingua',
    },
    MENU: {
      NEW: 'Nuova',
      ACTIONS: 'Azioni',
      CREATE_POST: 'Crea nuovo post',
      PAGES: 'Pages',
      FEATURES: 'Caratteristiche',
      APPS: 'App',
      DASHBOARD: 'Pannello di controllo',
      CALENDAR: 'Calendario',
      ROOMS: 'Camere',
      REPORT: 'Segnala guasti',
      USERSETTINGS: 'Impostazioni utente',
      SYSTEMSETTINGS: 'System Settings',
      LOGOCONFIGURATION: 'Configurazione del logo',
      EMAILCONFIGURATION: 'Configurazione e-mail',
      EQUIPMENTS: 'Attrezzature',
      STYLESETTINGS: 'Impostazioni di stile',
      CONFIGURATIONBYLOCATION: 'Configurazione per posizione',
      ROOMSETTINGS: 'Impostazioni stanza',
      ACCOUNTINFORMATION: 'Informazioni account',
      BOOKING: 'Prenotazione',
      CHECKOUTS: 'Checkout',
      VISITORS: 'Visitatori',
      VISITS: 'Visite',
      CONFIGURECUSTOMERADMIN: 'Configurare l\'amministratore del cliente',
      MRROOM: 'MrRoom',
      ADMMINBACKOFFICE: 'Back office amministrativo',
      ADMIN: 'Admin',
      MRVISITS: 'MrVisits',
    },
    ROOMS: {
      LOCATION: 'Posizione',
      ROOMS: 'Camere',
      EQUIPMENTS: 'Attrezzature',
      STARTDATE: 'Data d\'inizio',
      ENDDATE: 'Data di fine',
      STARTTIME: 'Ora di inizio',
      ENDTIME: 'Tempo scaduto',
      TIMEDURATION: 'Durata',
      ALL: 'Tutte',
      MEETINGROOM: 'Sala riunioni',
      DESK: 'Scrivania',
      PARKINGSEATS: 'Posti di parcheggio',
      SERVICE: 'Servizio',
      PLANT: 'pianta',
      BOOK: 'Libro',
      SERVICES: 'Servizi',
      CATERING: 'Ristorazione',
      ITSUPPORT: 'Supporto IT',
      MOBILEEQUIPMENT: 'Attrezzatura mobile',
      SPECIAL: 'Speciale',
      COMMINGSOON: 'Prossimamente',
      MAPPLANT: 'Pianta della mappa',
      ROOMBOOKING: 'Prenotazione della camera',
      LOCATIONS: 'Posizioni',
      RESOURCES: 'Risorse',
      REQUESTERNAME: 'Nome richiedente',
      SUBJECT: 'Soggetta',
      DESCRIPTION: 'Descrizione',
      ADDUSER: 'Aggiungi utente',
      ADDVISITORS: 'Aggiungi visitatori',
      CATERINGDESCRIPTION: 'Descrizione del catering',
      MOBILEEQUIPMENTDESCRIPTION: 'Descrizione dell\'apparecchiatura mobile',
      ITSUPPORTDESCRIPTION: 'Descrizione del supporto IT',
      SPECIALSERVICE: 'Servizio speciale',
      SPECIALSERVICEDESCRIPTION: 'Descrizione del servizio speciale',
      REQUESTEREMAIL: 'Email del richiedente',
    },
    ROOMBOOKING: {
      NEWBOOKING: 'Nuova prenotazione',
      LOCATIONS: 'Posizioni',
      BUILDING: 'Building',
      FLOOR: 'Floor',
      RESOURCES: 'Risorse',
      STARTDATE: 'Data d\'inizio',
      ENDDATE: 'Data di fine',
      STARTTIME: 'Ora di inizio',
      ENDTIME: 'Tempo scaduto',
      TIMEDURATION: 'Durata',
      DESKS: 'Scrivanie',
      REQUESTORNAME: 'Nome del richiedente',
      REQUESTOREMAIL: 'Email del richiedente',
      SUBJECT: 'Soggetta',
      ADDUSERS: 'Aggiungi utenti',
      ADDVISITORS: 'Aggiungi visitatori',
      PARKINGSEATS: 'Posti di parcheggio',
      CATERRING: 'Catering',
      MOBILEEQUIPMENT: 'Attrezzature mobili',
      ITSUPPORT: 'Supporto IT',
      CATERINGDESCRIPTION: 'Descrizione del catering',
      MOBILEEQUIPMENTDESCRIPTION: 'Descrizione dell\'apparecchiatura mobile',
      ITSUPPORTDESCRIPTION: 'Descrizione del supporto IT',
      SPECIALSERVICE: 'Servizio speciale',
      SPECIALSERVICEDESCRIPTION: 'Descrizione del servizio speciale',
      BOOK: 'Libro',
      CANCEL: 'Annulla',
      BACK: 'Indietro',
      EQUIPMENT: 'Attrezzature',
      STARTDATEISREQUIRED: 'La data di inizio è obbligatoria',
      ENDDATEISREQUIRED: 'La data di fine è obbligatoria',
      STARTTIMEISREQUIRED: 'È richiesta l\'ora di inizio',
      ENDTIMEISREQUIRED: 'È richiesta l\'ora di fine',
      ROOMS: 'Camere',
      DESCRIPTION: 'Descrizione',
      CLEANING: 'Pulizia',
      CLEANINGDESCRIPTION: 'Cleaning Descrizione',
      CHECKROOMAVAILABLITY: 'Verificare la disponibilità della camera',
      EDITBOOKING:'Edit Booking',

      CAPACITY:'Capacity', 
      COMPANY:'Company', 
      VISITORNAME:'Visitor Name',
      DRIVER: 'Driver',
      LICENSEPLATE: 'License Plate',
      USAGETYPE: 'Usage Type',
      SELECTBUILDING: 'Select Your Building',
      SELECTFLOOR: 'Select Your Floor'
    },
    DASHBOARD: {
      FROM: 'A partire dal',
      TO: 'Per',
      NOWINUSE: 'Ora in uso',
      FREEROOMS: 'Camere libere',
      FREEDESKS: 'Scrivanie gratuite',
      FREEPARKINGSEATS: 'Posti di parcheggio gratuiti',
      TODAY: 'Oggi',
      RESERVATIONSOFROOMS: 'Prenotazioni di camere',
      RESERVATIONSOFDESKS: 'Prenotazioni di scrivanie',
      RESERVATIONSOFPARKINGSEATS: 'Prenotazioni di posti di parcheggio',
      USERSMISSEDCHECKIN: 'Gli utenti non hanno effettuato il check-in',
      NORECENTCHECKIN: '  Nessun check-in recente',
      CURRENTMONTH: 'Corrente mese',
      RESERVATIONSPERROOM: 'Prenotazioni per camere',
      RESERVATIONSPERDESK: 'Prenotazioni per Desk',
      PARKINGSEATSRESERVATIONS: 'Prenotazione dei posti auto',
      RESERVATIONSPERUSER: 'Prenotazioni per utente',
      MISSINGRESERVATIONS: 'Prenotazioni mancanti',
      TIMEOFRESERVATIONSPERUSER: 'Tempo di prenotazione per utente',
      TIMEOFRESERVATIONSPERROOM: 'Tempo di prenotazione per camera',
      TIMEOFRESERVATIONSPERDESK: 'Tempo di prenotazione per desk',
      TOTALCOSTPERUSER: 'Costo totale per utente',
      DOWNLOADASCSVFILE: 'Scarica come file CSV',
    },
    USERSETTINGS: {
      UPLOADCSV: 'Carica CSV',
      IMPORTFROMLDAP: 'Importa da LDAP',
      AZUREACTIVEDIRECTORY: 'Azure Active Directory',
      SSO: 'SSO',
      ADD: 'Inserisci',
      NAME: 'Nome',
      EMAIL: 'E-mail',
      LOCATION: 'Posizione',
      ROLE: 'Ruolo',
      ACTION: 'Azione',
      FILTER: 'Filtro',
      CSVFILE: 'File CSV',
      DOWNLOADTEMPLATE: 'Scarica il modello',
      UPLOAD: 'Caricare',

      LDAPSERVER: 'Server LDAP',
      PORT: 'Porta',
      DISABLETLS: 'Disabilita TLS',
      IMPORT: 'Importare',
      CANCEL: 'Annulla',
      USERNAME: 'Nome utente',
      PASSWORD: 'Parola d\'ordine',
      CHECKCONNECTION: 'Verifica connessione',
      LDAPSERVERBASE: 'Base del server LDAP',
      LDAPSEARCHFILTER: 'Filtro di ricerca LDAP',
      DEFAULTADUSERMAILBOX: 'Filtro cassetta postale utente AD predefinito',
      CUSTOMLDAPFILTER: 'Filtro LDAP personalizzato',
      LDAPRFIDATTRIBUTE: 'Attributo LDAP RFID (facoltativo)',
      COUNTRY: 'Nazione',
      ADDUSER: 'Aggiungi utente',
      ADDROLES: 'Aggiungi ruoli',
      ROLENAME: 'Nome ruolo',
      ACCESSRIGHTS: 'Diritti di accesso',

    },

    USERACCESSRIGHTS: {
      BOOKABUILDING: 'Prenota un edificio',
      BOOKADESK: 'Prenota una scrivania',
      ORDERCATERING: 'Ordina il catering',
      ENDABOOKING: 'Termina una prenotazione',
      ACTIVATEINACTIVATE: 'Attiva / Disattiva sale riunioni',
      PARKINGCHECKOUT: 'Check-out del parcheggio',
      ACTIVATEINACTIVATEDISPLAYS: 'Attiva / disattiva i display',
      BOOKAFLOOR: 'Prenota un piano',
      BOOKAPARKINGSEATS: 'Prenota un posto auto',
      ORDERMOBILEEQUIPMENT: 'Ordina apparecchiature mobili',
      DELETEABOOKING: 'Elimina una prenotazione',
      ACTIVATEINACTIVATEDESK: 'Attiva / disattiva le postazioni',
      ACTIVATEINATIVATEKIOSKS: 'Attiva / disattiva i chioschi',
      ORDERSPECIALSERVICES: 'Ordina servizi speciali',
      BOOKAROOM: 'Prenotare una stanza',
      ORDERITSERVICES: 'Ordina servizi IT',
      EDITABOOKING: 'Modifica una prenotazione',
      EXTENDABOOKING: 'Estendi una prenotazione',
      ACTIVATEINACTIVATEPARKINGSEATS: 'Attiva / disattiva i sedili di parcheggio',
      ACTICATEINACTICATEVIEWPOINTS: 'Attiva / disattiva i ViewPoint',

    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: 'Abilita modifiche al logo',
      UPLOADLOGO: 'Carica il logo',
      URL: 'URL',
      OR: '(O)',
      SAVE: 'Salva',
    },
    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: 'Configurazione e-mail',
      EMAIL: 'E-mail',
      PASSWORD: 'Parola d\'ordine',
      HOSTSERVER: 'Server host',
      PORT: 'Porta',
      CHECKEMAIL: 'Controllare la posta elettronica',
      SAVE: 'Salva',
      TOEMAIL: 'Per e-mail',

    },

    STYLESETTINGS: {
      SYSTEMSTYLE: 'Stile di sistema',
      SIDEBUTTONCOLOR: 'Colore bottoni laterali',
      ACTIONBUTTONCOLOR: 'Colore del pulsante di azione',
      TOPTITLES: 'Titoli principali',
      TEXTCOLOR: 'Colore del testo',
      BACKGROUNDCOLOR: 'Colore di sfondo',
      KIOSKCHECKINSTYLE: 'Stile check-in chiosco',
      BACKGROUNDIMAGE: 'Immagine di sfondo',
      KIOSKINFORMATION: 'Informazioni sul chiosco',
      SERVICESVIEWPOINTSDISPLAYINFORMATION: 'Informazioni di visualizzazione dei punti di vista dei servizi',
      SAVE: 'Salva',
      CANCEL: 'Annulla',
      RESTORETODEFAULT: 'Ripristina impostazioni predefinite',
    },
    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: 'Cerca qui',
      COUNTRY: 'Nazione',
      LOCATION: 'Posizione',
      TIMEZONE: 'Fuso orario',
      ACTIONS: 'Azioni',
    },
    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: 'Allineamento dell\'attrezzatura',
      SEARCHHERE: 'Cerca qui',
      ICON: 'Icona',
      TITLE: 'Titolo',
      ACTION: 'Actrion',
      LEFT: 'Sinistra',
      RIGHT: 'Destro',
      TOP: 'Superiore',
      BOTTOM: 'Parte inferiore',
      ADD: 'Inserisci',
    },

    ACCOUTINFORMATION: {
      COMPANYNAME: 'Nome della ditta',
      CONTACTNAME: 'Nome del contatto',
      PHONENUMBER: 'Numero di telefono',
      COUNTRY: 'Nazione',
      RESELLER: 'Rivenditrice',
      EMAILTOREGISTRATION: 'E-mail alla registrazione',
      TYPEOFACCOUNT: 'Tipo di account',
      NUMBEROFROOMS: 'Numero di stanze',
      NUMBEROFROOMSDISPLAYS: 'Numero di stanze visualizzate',
      NUMBEROFDESKS: 'Numero di scrivanie',
      NUMBEROFDESKSDISPLAYS: 'Numero di banchi display',
      NUMBEROFPARKINGSPACES: 'Numero di posti auto',
      NUMBEROFSERVICESVIEWPOINTS: 'Numero di punti di visualizzazione dei servizi',
      NUMBEROFKIOSKS: 'Numero di chioschi',
      ACCOUNTID: 'Account ID',
      VALIDFROM: 'Valido dal',
      VALIDTO: 'Valido per',
      CONTACTSUPPORT: 'Contatta il supporto',
      MESSAGE: 'Messaggio',
      CLOSE: 'Vicina',
      SEND: 'Spedire',
    },
    LOGINGPAGE: {
      WELCOMETOMRROOMS: 'Benvenuto in MrRooms',
      NEWHERE: 'Nuovo qui?',
      DEMOACCOUNT: 'Conto demo',
      ENTERYOURDETAILSTOCREATEYOURACCOUNT: 'Inserisci i tuoi dati per creare il tuo account',
      COMPANYNAME: 'Nome della ditta',
      CONTACTNAME: 'Nome del contatto',
      PHONE: 'Telefono',
      COUNTRY: 'Nazione',
      CONFIRMPASSWORD: 'conferma password',
      ACCEPTTERMSCONDITIONS: 'Accetta termini e condizioni',
      TERMSANDCONDITIONS: 'Termini e Condizioni',
      EMAIL: 'E-mail',
      PASSWORD: 'Parola d\'ordine',
      FORGOTPASSWORD: 'Ha dimenticato la password',
      DISCOVERAMAZINGWORKSPACE: 'Scopri Amazing Workspace',
      SERVICEVIEWPOINTS: 'Punti di vista del servizio',
      KIOSKSMAPPLANTS: 'Chioschi Mappa Piante',
      ENTERYOUREMAILTORESETYOURPASSWORD: 'Inserisci la tua email per reimpostare la password',
      SUBMIT: 'Invia',
      CANCEL: 'Annulla',
      SIGNIN: 'Registrati',
      EMAILIDISREQUIRED: 'L\'ID e- mail è obbligatorio',
      PASSWORDISREQUIRED: 'E \'richiesta la password',
      THELOGINDETAILSAREINCORRECT: 'I dettagli di accesso non sono corretti',
      COMPANYNAMEISREQUIRED: 'Il nome dell\'azienda è obbligatorio',
      NAMEISREQUIRED: 'Il nome è obbligatorio',
      PHONENUMBERISREQUIRED: 'Il numero di telefono è obbligatorio',
      COUNTRYISREQUIRED: 'Il paese è obbligatorio',
      EMAILISREQUIRED: 'E-mail richiesta',
      CONFIRMPASSWORDISREQUIRED: 'Conferma password richiesta',
      ACCEPTTSCSISREQUIRED: 'È necessario accettare i termini e le condizioni',
    },
    CALENDAR: {
      TODAY: 'Oggi',
      MEETINGROOMS: 'Sale riunioni',
      DESK: 'Scrivania',
      PARKINGSEATS: 'Posti di parcheggio',
      MONTH: 'Mese',
      WEEK: 'Settimana',
      DAY: 'Giorno',
      SUNDAY: 'Domenica',
      MONDAY: 'Lunedi',
      TUESDAY: 'martedì',
      WEDNESDAY: 'mercoledì',
      THURSDAY: 'giovedi',
      FRIDAY: 'Venerdì',
      SATURDAY: 'Sabato',

    },

  }
};
